module.exports = __webpack_public_path__ + "img/TS_ICON_CLUES.d7363f7a.png";